<template>
  <div class="Survey">
    <!-- s: header -->
    <header id="header-slidePanel">
      <h2>설문 만들기</h2>
      <div class="btn_back">
        <a @click="slidePanelClose">
          <img src="@/assets/images/btn_close.png" width="50" alt="이전"/>
        </a>
      </div>
      <button class="btn-write" @click="formSend">등록</button>
    </header>
    <!-- e: header -->
    <div class="contents-area-slidePanel">
      <p class="surver-text mrg-top-30">설문하실 내용을 입력하신 후, 등록을 선택해 주세요.</p>
      <div class="mrg-btm-30">
        <ul>
          <li v-for="(data, index) in list" :key="index">
            <h3 class="sub-title">
              설문 {{ index + 1 }}
              <button class="img-close" v-if="list.length > 1" @click="removeSurver(index)"></button>
            </h3>
            <div class="form-box">
              <div class="input-box">
                <div class="input-item"><input type="text" placeholder="설문을 입력하세요." v-model="data.Poll"></div>
              </div>
            </div>
            <ul>
              <li v-for="(item, num) in data.Item" :key="num">
                <div class="form-box border mrg-top-10">
                  <div class="input-box">
                    <div class="input-title"><span>항목 {{ num + 1 }}</span></div>
                    <div class="input-item pdd-right-50">
                      <input type="text" placeholder="항목을 입력하세요." v-model="item.Name">
                      <button class="ir btn-input-del" @click="removeSurverItem(index, num)">삭제</button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="flex justify-between mrg-top-10">
              <div class="width-100 mrg-right-10" v-if="index == list.length-1">
                <button class="btn-surver btn-bule" @click="addSurver">설문추가</button>
              </div>
              <div class="width-100 mrg-right-10">
                <button class="btn-surver btn-white border" @click="addSurverItem(index)">항목추가</button>
              </div>
              <div class="checkbox-list width-100">
                <span><label class="ckb square"><input type="checkbox" v-model="data.Dupl" true-value="Y"
                                                       false-value="N"/><i></i>복수응답</label></span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Survey',
  props: ['nBoardNum', 'oPoll'],
  data() {
    return {
      list: [
        {
          "Num": "",
          "Poll": "",             // 설문조사 :: 제목
          "Dupl": "N",            // 복수응답설정
          "Item": [               // 항목 내역
            {"Name": ""},       // 항목 1
            {"Name": ""}        // 항목 2
          ]
        }
      ],
      mode: 'register'                 // 등록, 수정모드
    }
  },
  // 계산된 속성
  computed: {},
  // 감시자
  watch: {},
  // $el 생성전
  created() {
  },
  // $el 생성후
  mounted() {
    window.callbackBackKey = this.callbackBackKey;
    if (this.oPoll) {
      console.log(this.oPoll)
      this.mode = 'modify';
      this.list = this.oPoll;
    } else {
      console.log(this.oPoll)
    }
  },
  methods: {
    // APP 뒤로가기
    callbackBackKey() {
      this.slidePanelClose();
    },
    // 설문 추가
    addSurver() {
      this.list.push({"Num": "", "Poll": "", "Dupl": "N", "Item": [{"Name": ""}, {"Name": ""}]});
    },
    // 설문삭제
    removeSurver(index) {
      this.list.splice(index, 1);
    },
    // 설문 항목 추가
    addSurverItem(index) {
      this.list[index].Item.push({"Name": ""});
    },
    // 설문 항목 삭제
    removeSurverItem(index, num) {
      if (this.list[index].Item.length < 3) {
        this.toastMsg('설문 당 최소 2개의 항목은 작성이 필요합니다.', 1500);
        return false;
      }
      this.list[index].Item.splice(num, 1);
    },
    // 설문 등록, 수정
    formSend() {
      let formData = new FormData();
      formData.append('oPollData', JSON.stringify(this.list));
      // if (this.mode == 'modify'){
      formData.append('nBoardNum', this.nBoardNum);
      // }
      this.ajaxPostAuth('/api/v1/board/write/poll/' + this.mode, formData, this.formSendResult);

    },
    // 설문 등록, 수정 결과
    formSendResult(response) {
      if (response.result.code == 0) {
        let param = {};
        param.result = 'close';
        param.nBoardNum = response.oBoardInfo.info.nBoardNum;
        param.nPollCnt = this.list.length;
        this.slidePanelClose(param);
      } else {
        this.toastMsg(response.result.resultNoti.message, 1500);
      }
    },
  },
  // $el 해체
  destroyed() {

  }
}
</script>

<style scoped>
.btn-write {
  position: absolute;
  top: 8px;
  right: 15px;
  background: #2e9cff;
  color: #fff;
  border: 0;
  padding: 5px 10px;
  font-size: 16px;
  border-radius: 5px;
}

.checkbox-list {
  padding-top: 8px;
  padding-left: 10px;
  font-size: 14px;
}

.surver-text {
  color: #737373;
  font-weight: 400;
  font-size: 13px;
  text-align: center
}

.sub-title {
  color: #000;
  font-size: 16px;
  margin-top: 20px;
  font-weight: 400;
  position: relative
}

.sub-title .img-close {
  text-indent: -999px;
  cursor: pointer;
  position: absolute;
  top: 3px;
  right: 0px;
  background: url('../../assets/images/file_del_btn.png') right top no-repeat;
  background-size: 20px 20px;
  width: 20px;
  height: 20px;
  display: inline-block;
  z-index: 3;
}

.form-box {
  border-radius: 10px;
}

.form-box.border {
  border: 2px solid #eeeeee;
}

.input-title {
  justify-content: center;
  color: #bdbdbd;
}

.form-box.border input[type=text], input[type=password], input[type=number] {
  border: none;
  background: none;
  color: #000;
  text-indent: 0;
}

.btn-surver {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  text-align: center;
  width: 100%;
  display: block;
  border: 0;
  border-radius: 10px;
  font-weight: 300;
}

.btn-surver.border {
  border: 2px solid #eeeeee;
}
</style>
